import { money, num, negClass, weekdayName } from './format'

/** The rostering table: GET /daily weekdays[]. */
export default function WeekdayTable({ weekdays }) {
  if (!weekdays?.length) return <p className="text-sm text-slate-500 py-3">No working days in this period yet.</p>
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-[13px]">
        <thead>
          <tr className="text-xs text-slate-500 border-b border-slate-300">
            <th className="text-left font-semibold px-2.5 py-2">Weekday</th>
            <th className="text-right font-semibold px-2.5 py-2">Avg orders</th>
            <th className="text-right font-semibold px-2.5 py-2">Avg labour hrs</th>
            <th className="text-right font-semibold px-2.5 py-2">Orders per labour hr</th>
            <th className="text-right font-semibold px-2.5 py-2">Avg profit</th>
            <th className="text-right font-semibold px-2.5 py-2">Break-even orders</th>
          </tr>
        </thead>
        <tbody>
          {weekdays.map((w) => (
            <tr key={String(w.weekday)} className="border-b border-slate-100 tabular-nums">
              <td className="text-left px-2.5 py-1.5">{weekdayName(w.weekday)}</td>
              <td className="text-right px-2.5 py-1.5">{num(w.avg_orders)}</td>
              <td className="text-right px-2.5 py-1.5">{num(w.avg_hours, 1)}</td>
              <td className="text-right px-2.5 py-1.5">{num(w.orders_per_hour, 1)}</td>
              <td className={`text-right px-2.5 py-1.5 ${negClass(w.avg_profit)}`}>{money(w.avg_profit)}</td>
              <td className="text-right px-2.5 py-1.5">{num(w.avg_breakeven)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
